export const rules = {
  data() {
    return {
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        mobile: [
          {
            required: true,
            pattern:/^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
            //pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
            message: "手机号码有误，请重填",
            trigger: "blur",
          },
        ],
        remark_mobiles: [
          {
            required: true,
            pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
            message: "手机号码有误，请重填",
            trigger: "blur",
          },
        ],
        telephone: [
          {
            required: false,
            pattern: /^(\(\d{3,4}\)|\d{3,4}-|\s)?\d{7,14}$/,
            message: "固定电话有误，请重填",
            trigger: "blur",
          },
        ],
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.onSave();
          return true;
        } else {
          return false;
        }
      });
    },
  },
}

export const rulesRecord = {
  data() {
    return {
      rulesR: {
        content: [{ required: true, message: "请填写跟进记录", trigger: "blur" }],
        next_time: [{ required: true, message: "请输入下次跟进时间", trigger: "blur" }]
      },
    }
  },
  methods: {
    submitForm() {
      this.$refs["ruleRecord"].validate((valid) => {
        if (valid) {
          this.saveRecord();
          return true;
        } else {
          return false;
        }
      });
    },
  },
}